import { render, staticRenderFns } from "./WrapperScrollbar.vue?vue&type=template&id=b4e2fea2&scoped=true"
import script from "./WrapperScrollbar.vue?vue&type=script&lang=js"
export * from "./WrapperScrollbar.vue?vue&type=script&lang=js"
import style0 from "./WrapperScrollbar.vue?vue&type=style&index=0&id=b4e2fea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e2fea2",
  null
  
)

export default component.exports